<!-- ITP-E-180-07: everything the bar shows moves as one, dragged by the name or moved with the arrow keys on it. The
     voice strip shares its place (ITP-E-185-03). -->
<div class="call-overlay" #overlayElement cdkDrag [cdkDragFreeDragPosition]="overlay.position"
     [cdkDragConstrainPosition]="overlay.constrain" (cdkDragEnded)="overlay.dropped($event)">
    <ng-container *ngIf="view$ | async as view">
        <div class="call-bar call-outcome call-blocked" role="alert" *ngIf="view.state.phase === 'idle' && view.state.micBlocked">
            <span class="call-bar-handle" cdkDragHandle tabindex="0" role="button"
                  aria-roledescription="move handle" aria-keyshortcuts="ArrowUp ArrowDown ArrowLeft ArrowRight Home"
                  title="Drag to move the call bar · arrow keys move it · double-click puts it back"
                  (keydown)="overlay.onKey($event)" (dblclick)="overlay.reset()">
                <i class="fa-solid fa-microphone-slash call-outcome-icon"></i>
                <span class="call-outcome-label">Your microphone is blocked</span>
            </span>
            <span class="call-blocked-hint">Allow it in the browser's site settings, then call again.</span>
            <button type="button" class="call-outcome-close" (click)="onDismissMicBlocked()" aria-label="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <!-- Someone moved the call to Meet and it ended here (ITP-E-172-03): follow them, or close it. -->
        <div class="call-bar call-outcome call-moved" role="status" aria-live="polite"
             *ngIf="view.state.phase === 'idle' && view.state.movedToMeet as moved">
            <span class="call-bar-handle" cdkDragHandle tabindex="0" role="button"
                  aria-roledescription="move handle" aria-keyshortcuts="ArrowUp ArrowDown ArrowLeft ArrowRight Home"
                  title="Drag to move the call bar · arrow keys move it · double-click puts it back"
                  (keydown)="overlay.onKey($event)" (dblclick)="overlay.reset()">
                <i class="fa-solid fa-arrow-up-right-from-square call-moved-icon"></i>
                <span class="call-outcome-label">{{ moved.by }} moved the call to Meet</span>
            </span>
            <button type="button" class="call-outcome-action" (click)="onFollowToMeet(moved.meetingId)" aria-label="Open in Meet">
                <i class="fa-solid fa-video"></i>
                <span>Open in Meet</span>
            </button>
            <button type="button" class="call-outcome-close" (click)="onDismissMovedToMeet()" aria-label="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="call-bar call-outcome" role="status" aria-live="polite" *ngIf="view.state.phase === 'ended'">
            <span class="call-bar-handle" cdkDragHandle tabindex="0" role="button"
                  aria-roledescription="move handle" aria-keyshortcuts="ArrowUp ArrowDown ArrowLeft ArrowRight Home"
                  title="Drag to move the call bar · arrow keys move it · double-click puts it back"
                  (keydown)="overlay.onKey($event)" (dblclick)="overlay.reset()">
                <i class="fa-solid call-outcome-icon" [class.fa-video-slash]="view.state.mode === 'video'"
                   [class.fa-phone-xmark]="view.state.mode !== 'video'"></i>
                <span class="call-bar-name">{{ view.state.peerName }}</span>
            </span>
            <span class="call-outcome-label">{{ view.label }}</span>
            <ng-container *ngIf="view.state.isCaller">
                <button type="button" class="call-outcome-action" (click)="onCallAgain()" aria-label="Call again">
                    <i class="fa-solid fa-phone"></i>
                    <span>Call again</span>
                </button>
                <button type="button" class="call-outcome-action" (click)="onSendMessage()" aria-label="Send a message">
                    <i class="fa-solid fa-message"></i>
                    <span>Send a message</span>
                </button>
            </ng-container>
            <button type="button" class="call-outcome-close" (click)="onDismiss()" aria-label="Close">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <!-- Another tab holds the call (ITP-E-175-01): shown here, joined nowhere, and End call still ends it.
             Switch here (ITP-E-175-02) moves the call into this tab. A polite status (ITP-E-175-04): screen readers hear
             it appear and change, never each tick of the timer, and it never takes the focus. -->
        <div class="call-bar call-elsewhere" role="status" aria-live="polite" aria-atomic="false"
             aria-label="Voice call in another tab" *ngIf="view.state.phase === 'elsewhere'">
            <span class="call-bar-handle" cdkDragHandle tabindex="0" role="button"
                  aria-roledescription="move handle" aria-keyshortcuts="ArrowUp ArrowDown ArrowLeft ArrowRight Home"
                  title="Drag to move the call bar · arrow keys move it · double-click puts it back"
                  (keydown)="overlay.onKey($event)" (dblclick)="overlay.reset()">
                <i class="fa-solid fa-phone call-bar-icon" aria-hidden="true"></i>
                <span class="call-bar-name" *ngIf="view.state.isGroup ? view.state.title : view.state.peerName as name">{{ name }}</span>
            </span>
            <span class="call-elsewhere-label">{{ view.state.movedElsewhere ? 'Call moved to another tab' : 'On a call in another tab' }}</span>
            <span class="call-bar-timer" role="timer" aria-live="off"><span aria-hidden="true">· </span>{{ view.label }}</span>
            <button type="button" class="call-outcome-action call-switch-here" #switchHereButton (click)="onSwitchHere()"
                    aria-label="Switch here" title="Move the call into this tab">
                <i class="fa-solid fa-arrow-right-to-bracket" aria-hidden="true"></i>
                <span>Switch here</span>
            </button>
            <button type="button" class="call-bar-hang-up" (click)="onHangUp()" aria-label="End call"
                    [title]="hangUpTitle(view.state)">
                <i class="fa-solid fa-phone-hangup" aria-hidden="true"></i>
                <span>End call</span>
            </button>
        </div>
        <!-- A call this tab holds is the compact call view's (ITP-E-185-03), drawn by app-video-call-card: the voice strip
             where this bar sits, or the video card. The bar keeps the blocked microphone, the outcome and the passive bar. -->
    </ng-container>
</div>
